import { Card } from '@bancobarigui/barihaus';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { YearComparison } from '../types';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface YearComparisonChartProps {
  data: YearComparison[];
  loading?: boolean;
}

export function YearComparisonChart({ data, loading = false }: YearComparisonChartProps) {
  const chartData = {
    labels: data.map(item => item.month),
    datasets: [
      {
        label: 'Ano Atual',
        data: data.map(item => item.anoAtual),
        backgroundColor: '#1890ff',
        borderRadius: 4,
      },
      {
        label: 'Ano Anterior',
        data: data.map(item => item.anoAnterior),
        backgroundColor: '#d9d9d9',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title="Comparativo ano anterior vs ano atual" bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '300px' }}>
          <Bar data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
